import Vue from 'vue';
import router from 'vue-router';

Vue.use(router);

export default new router({
  routes: [
    {
      path: '/',
      redirect: '/message'
    },
    {
      path: '/',
      component: resolve => require(['../components/common/Home.vue'], resolve),
      children: [
        //消息中心
        {
          path: '/message',
          component: resolve => require(['../components/page/message/Message.vue'], resolve),
          meta: {title: '消息中心'}
        },

        // 中台二期需求
        // 供应商-商品维护管理
        {
          path: '/partnergoods&:page&:pagesize',
          component: resolve => require(['../components/page/partnergoods/PartnerGoods.vue'], resolve),
          meta: {title: '商品维护管理'}
        },
        // 供应商-商品修改List
        {
          path: '/partnergoodseditlist&:page&:pagesize',
          component: resolve => require(['../components/page/partnergoods/PartnerGoodsEditList.vue'], resolve),
          meta: {title: '商品修改列表'}
        },
        // 供应商-商品修改
        {
          path: '/compileProductEdit&:id&:page&:pagesize&:CategoryId&:CategoryName',
          component: resolve => require(['../components/page/partnergoods/compileProductEdit.vue'], resolve),
          meta: {title: '编辑商品'}
        },
        // 供应商-商品修改查看详情
        {
          path: '/supplierDetailsEdit&:id&:page&:pagesize',
          component: resolve => require(['../components/page/partnergoods/supplierDetailsEdit.vue'], resolve),
          meta: {title: '查看详情'}
        },
        //发布商品返回的选择品类
        {
          path: '/changeclass',
          component: resolve => require(['../components/page/partnergoods/ChangeClass.vue'], resolve),
          meta: {title: '选择品类'}
        },
        //编辑商品返回的选择品类
        {
          path: '/updateclass&:id&:page&:pagesize',
          component: resolve => require(['../components/page/partnergoods/UpdateClass.vue'], resolve),
          meta: {title: '选择品类'}
        },
        {
          path: '/releaseGoods',
          component: resolve => require(['../components/page/partnergoods/releaseGoods.vue'], resolve),
          meta: {title: '发布商品'}
        },
        {
          path: '/compileProduct&:id&:page&:pagesize&:CategoryId&:CategoryName',
          component: resolve => require(['../components/page/partnergoods/compileProduct.vue'], resolve),
          meta: {title: '编辑商品'}
        },
        {
          path: '/supplierDetails&:id&:page&:pagesize',
          component: resolve => require(['../components/page/partnergoods/supplierDetails.vue'], resolve),
          meta: {title: '查看详情'}
        },
        {
          path: '/operationlog&:userType&:spuid',
          component: resolve => require(['../components/page/partnergoods/OperationLog.vue'], resolve),
          meta: {title: '操作日志'}
        },
        {
          path: '/transactionrecord',
          component: resolve => require(['../components/page/partnergoods/TransactionRecord.vue'], resolve),
          meta: {title: '成本价记录'}
        },
        {
          path: '/inventorywater',
          component: resolve => require(['../components/page/partnergoods/InventoryWater.vue'], resolve),
          meta: {title: '库存流水'}
        },

        // 内容待审核商品
        {
          path: '/contentManagement&:page&:pagesize',//内容待审核商品管理
          component: resolve => require(['../components/page/content/ContentManagement.vue'], resolve),
          meta: {title: '内容待审核商品管理'}
        },
        {
          path: '/contentAduit&:id&:page&:pagesize',//内容待审核
          component: resolve => require(['../components/page/content/ContentAduit.vue'], resolve),
          meta: {title: '内容待审核商品'}
        },
        {
          path: '/contentEdit&:id&:page&:pagesize',//内容待编辑
          component: resolve => require(['../components/page/content/ContentEdit.vue'], resolve),
          meta: {title: '内容待编辑商品'}
        },
        {
          path: '/contentDetail&:id&:page&:pagesize',//内容详情
          component: resolve => require(['../components/page/content/ContentDetail.vue'], resolve),
          meta: {title: '内容查看详情'}
        },


        // 采购待审核商品
        {
          path: '/auditManagement&:page&:pagesize',//采购待审核商品管理
          component: resolve => require(['../components/page/purchase/AuditManagement.vue'], resolve),
          meta: {title: '采购待审核商品管理'}
        },
        {
          path: '/purchaseAduit&:id&:page&:pagesize',//采购待审核
          component: resolve => require(['../components/page/purchase/PurchaseAduit.vue'], resolve),
          meta: {title: '采购待审核商品'}
        },
        {
          path: '/purchaseEdit&:id&:page&:pagesize',//采购待编辑
          component: resolve => require(['../components/page/purchase/PurchaseEdit.vue'], resolve),
          meta: {title: '采购待编辑商品'}
        },
        {
          path: '/purchaseDetail&:id&:page&:pagesize',//采购详情
          component: resolve => require(['../components/page/purchase/PurchaseDetail.vue'], resolve),
          meta: {title: '采购查看详情'}
        },

        //运营管理
        {
          path: '/operationgoods&:page&:pagesize',
          component: resolve => require(['../components/page/operation/OperationGoods.vue'], resolve),
          meta: {title: '待上架商品管理'}
        },
        {
          path: '/putAwaying&:id&:page&:pagesize',
          component: resolve => require(['../components/page/operation/putAwaying.vue'], resolve),
          meta: {title: '待上架查看详情'}
        },
        {
          path: '/putAwayed&:id&:page&:pagesize',
          component: resolve => require(['../components/page/operation/putAwayed.vue'], resolve),
          meta: {title: '已上架查看详情'}
        },
        {
          path: '/soldOuted&:id&:page&:pagesize',
          component: resolve => require(['../components/page/operation/soldOuted.vue'], resolve),
          meta: {title: '已下架查看详情'}
        },
        {
          path: '/canceled&:id&:page&:pagesize',
          component: resolve => require(['../components/page/operation/canceled.vue'], resolve),
          meta: {title: '已作废查看详情'}
        },
        {
          path: '/redoctGoods&:id&:page&:pagesize',
          component: resolve => require(['../components/page/operation/redoctGoods.vue'], resolve),
          meta: {title: '编辑商品'}
        },

        // 商品管理
        {
          path: '/goodslist',
          component: resolve => require(['../components/page/goods/GoodsList.vue'], resolve),
          meta: {title: '在售商品管理'}
        },
        {
          path: '/addgoods',
          component: resolve => require(['../components/page/goods/AddGoods.vue'], resolve),
          meta: {title: '新增商品'}
        },
        {
          path: '/editgoods&:id',
          component: resolve => require(['../components/page/goods/EditGoods.vue'], resolve),
          meta: {title: '在售商品编辑'}
        },
        {
          path: '/salegoods',
          component: resolve => require(['../components/page/goods/SaleGoods.vue'], resolve),
          meta: {title: '待售商品管理'}
        },
        {
          path: '/editsale&:id',
          component: resolve => require(['../components/page/goods/EditSale.vue'], resolve),
          meta: {title: '待售商品编辑'}
        },
        {
          path: '/outofstock',
          component: resolve => require(['../components/page/goods/OutofStock.vue'], resolve),
          meta: {title: '缺货商品管理'}
        },
        {
          path: '/editoutof&:id',
          component: resolve => require(['../components/page/goods/EditOutof.vue'], resolve),
          meta: {title: '缺货商品编辑'}
        },

        {
          path: '/goodsbrand',
          component: resolve => require(['../components/page/goods/GoodsBrand.vue'], resolve),
          meta: {title: '商品品牌管理'}
        },
        {
          path: '/commodityProperty',
          component: resolve => require(['../components/page/goods/CommodityProperty.vue'], resolve),
          meta: {title: '商品属性管理'}
        },
        {
          path: '/categoryManagement',
          component: resolve => require(['../components/page/goods/categoryManagement.vue'], resolve),
          meta: {title: '商品品类管理'}
        },

        // 销售管理
        {
          path: '/orderlist',
          component: resolve => require(['../components/page/order/OrderList.vue'], resolve),
          meta: {title: '平台订单管理'}
        },
        {
          path: '/orderdetails&:id',
          component: resolve => require(['../components/page/order/OrderDetails.vue'], resolve),
          meta: {title: '平台订单详情'}
        },
        {
          path: '/partnerorder',
          component: resolve => require(['../components/page/order/PartnerOrder.vue'], resolve),
          meta: {title: '供应商订单管理'}
        },
        {
          path: '/partnerorderdetails&:id',
          component: resolve => require(['../components/page/order/PartnerOrderDetails.vue'], resolve),
          meta: {title: '供应商订单详情'}
        },
        {
          path: '/createreturns&:order_id',
          component: resolve => require(['../components/page/order/CreateReturns.vue'], resolve),
          meta: {title: '创建退货单'}
        },
        {
          path: '/returnslist',
          component: resolve => require(['../components/page/order/ReturnsList.vue'], resolve),
          meta: {title: '财务退款单管理'}
        },
        {
          path: '/returnsdetails&:id',
          component: resolve => require(['../components/page/order/ReturnsDetails.vue'], resolve),
          meta: {title: '财务退款单详情'}
        },

        // 会员管理
        {
          path: '/userlist',
          component: resolve => require(['../components/page/user/UserList.vue'], resolve),
          meta: {title: '会员管理'}
        },
        {
          path: '/seeuser&:id',
          component: resolve => require(['../components/page/user/SeeUser.vue'], resolve),
          meta: {title: '查看会员'}
        },

        // 评论管理
        {
          path: '/evaluateList',
          component: resolve => require(['../components/page/evaluate/evaluateList.vue'], resolve),
          meta: {title: '评论管理'}
        },

        //客服退货单管理
        {
          path: '/customerList',
          component: resolve => require(['../components/page/customer/customerList.vue'], resolve),
          meta: {title: '退货单管理'}
        },
        {
          path: '/providerList',
          component: resolve => require(['../components/page/customer/providerList.vue'], resolve),
          meta: {title: '供应商退货单管理'}
        },
        {
          path: '/customerDetails&:id',
          component: resolve => require(['../components/page/customer/customerDetails.vue'], resolve),
          meta: {title: '查看退货单'}
        },
        {
          path: '/providerDetail&:id',
          component: resolve => require(['../components/page/customer/providerDetail.vue'], resolve),
          meta: {title: '供应商查看退货单'}
        },

        // 供应商管理
        {
          path: '/partnerlist',
          component: resolve => require(['../components/page/partner/PartnerList.vue'], resolve),
          meta: {title: '供应商管理'}
        },
        {
          path: '/addpartner',
          component: resolve => require(['../components/page/partner/AddPartner.vue'], resolve),
          meta: {title: '新增供应商'}
        },
        {
          path: '/seepartner&:id',
          component: resolve => require(['../components/page/partner/SeePartner.vue'], resolve),
          meta: {title: '查看供应商'}
        },
        {
          path: '/editpartner&:id',
          component: resolve => require(['../components/page/partner/EditPartner.vue'], resolve),
          meta: {title: '编辑供应商'}
        },

        // // 返利管理
        // {
        //   path: '/rebate',
        //   component: resolve => require(['../components/page/rebate/Rebate.vue'], resolve),
        //   meta: {title: '返利管理'}
        // },
        // {
        //   path: '/rebatelist',
        //   component: resolve => require(['../components/page/rebate/RebateList.vue'], resolve),
        //   meta: {title: '返利明细账单'}
        // },

        // 权限管理
        {
          path: '/index',
          component: resolve => require(['../components/page/system/Index.vue'], resolve),
          meta: {title: '权限列表'}
        },
        {
          path: '/stafflist',
          component: resolve => require(['../components/page/system/StaffList.vue'], resolve),
          meta: {title: '员工列表'}
        },
        {
          path: '/addstaff',
          component: resolve => require(['../components/page/system/AddStaff.vue'], resolve),
          meta: {title: '新增员工'}
        },
        {
          path: '/editstaff&:id',
          component: resolve => require(['../components/page/system/EditStaff.vue'], resolve),
          meta: {title: '编辑员工'}
        },
        {
          path: '/rolelist',
          component: resolve => require(['../components/page/system/RoleList.vue'], resolve),
          meta: {title: '角色列表'}
        },
        {
          path: '/addrole',
          component: resolve => require(['../components/page/system/AddRole.vue'], resolve),
          meta: {title: '新增角色'}
        },
        {
          path: '/editrole&:id',
          component: resolve => require(['../components/page/system/EditRole.vue'], resolve),
          meta: {title: '编辑角色'}
        },
        // app版本设置
        {
          path: '/appList',
          component: resolve => require(['../components/page/app/appList.vue'], resolve),
          meta: {title: 'app版本列表'}
        },
        {
          path: '/addApp&:id',
          component: resolve => require(['../components/page/app/addApp.vue'], resolve),
          meta: {title: '新增app版本'}
        },

        // 权限管理
        {
          path: '/authorityList',
          component: resolve => require(['../components/page/system/AuthorityList.vue'], resolve),
          meta: {title: '权限管理列表'}
        },
        {
          path: '/addAuthority',
          component: resolve => require(['../components/page/system/AddAuthority.vue'], resolve),
          meta: {title: '新增权限管理'}
        },
        {
          path: '/searchAuthority&:id',
          component: resolve => require(['../components/page/system/SearchAuthority.vue'], resolve),
          meta: {title: '查看权限管理'}
        },
        {
          path: '/editAuthority&:id',
          component: resolve => require(['../components/page/system/EditAuthority.vue'], resolve),
          meta: {title: '修改权限管理'}
        },
        // 操作日志
        {
          path: '/searchLog',
          component: resolve => require(['../components/page/system/SearchLog.vue'], resolve),
          meta: { title: '操作日志'}
        },
        // 登陆日志
        {
          path: '/loginLog',
          component: resolve => require(['../components/page/system/LoginLog.vue'], resolve),
          meta: { title: '登陆日志'}
        },

        //统计管理
        {
          path: '/statisticalManagement',
          component: resolve => require(['../components/page/statistics/statisticalManagement.vue'], resolve),
          meta: {title: '简单统计'}
        },

        //营销管理
        //1.banner管理
        {
          path: '/bannerManagement',
          component: resolve => require(['../components/page/marketing/bannerManagement.vue'], resolve),
          meta: {title: 'banner管理'}
        },
        {
          path: '/advertManagement&:id&:status',
          component: resolve => require(['../components/page/marketing/advertManagement.vue'], resolve),
          meta: {title: '广告管理'}
        },
        {
          path: '/addAdvert&:id&:status',
          component: resolve => require(['../components/page/marketing/addAdvert.vue'], resolve),
          meta: {title: '新建广告'}
        },
        {
          path: '/editAdvert&:id&:status&:banner_id',
          component: resolve => require(['../components/page/marketing/editAdvert.vue'], resolve),
          meta: {title: '新建广告'}
        },
        //2.标签管理
        {
          path: '/labelManagement',
          component: resolve => require(['../components/page/marketing/labelManagement.vue'], resolve),
          meta: {title: '标签管理'}
        },
        {
          path: '/addLabel',
          component: resolve => require(['../components/page/marketing/addLabel.vue'], resolve),
          meta: {title: '新建标签'}
        },
        {
          path: '/editLabel&:id',
          component: resolve => require(['../components/page/marketing/editLabel.vue'], resolve),
          meta: {title: '编辑标签', permission: true}
        },

        //分类管理
        {
          path: '/assort',
          component: resolve => require(['../components/page/assort/assortManagement.vue'], resolve),
          meta: {title: '分类管理', permission: true}
        },
        //新增三级分类配置
        {
          path: '/addAssort&:parent_id&:start_time&:end_time',
          component: resolve => require(['../components/page/assort/addAssort.vue'], resolve),
          meta: {title: '三级分类配置', permission: true}
        },
        //编辑三级分类配置
        {
          path: '/editAssort&:id&:start_time&:end_time',
          component: resolve => require(['../components/page/assort/editAssort.vue'], resolve),
          meta: {title: '三级分类配置', permission: true}
        },

        //促销管理
        {
          path: '/couponslist',
          component: resolve => require(['../components/page/coupons/CouponsList.vue'], resolve),
          meta: {title: '优惠券管理'}
        },
        {
          path: '/addcoupons',
          component: resolve => require(['../components/page/coupons/AddCoupons.vue'], resolve),
          meta: {title: '添加优惠券'}
        },
        {
          path: '/couponsdetails&:id',
          component: resolve => require(['../components/page/coupons/CouponsDetails.vue'], resolve),
          meta: {title: '优惠券详情'}
        },
        {
          path: '/editcoupons&:id',
          component: resolve => require(['../components/page/coupons/EditCoupons.vue'], resolve),
          meta: {title: '编辑优惠券'}
        },
        {
          path: '/couponrules',
          component: resolve => require(['../components/page/coupons/CouponRules.vue'], resolve),
          meta: {title: '优惠券规则'}
        },
        {
          path: '/couponruledetail&:id',
          component: resolve => require(['../components/page/coupons/CouponRuleDetail.vue'], resolve),
          meta: {title: '优惠券规则明细'}
        },
        {
          path: '/detailssuccess&:id',
          component: resolve => require(['../components/page/coupons/DetailsSuccess.vue'], resolve),
          meta: {title: '成功发放明细'}
        },
        {
          path: '/detailsused&:id',
          component: resolve => require(['../components/page/coupons/DetailsUsed.vue'], resolve),
          meta: {title: '使用明细'}
        },
        // 优惠券规则
        {
          path: '/addcouponrule&:id&:type',
          component: resolve => require(['../components/page/coupons/AddCouponRule.vue'], resolve),
          meta: {title: '新增优惠券规则'}
        },

        // 推广人管理
        {
          path: '/promoterList',
          component: resolve => require(['../components/page/promoter/PromoterList.vue'], resolve),
          meta: {title: '推广人信息'}
        },
        {
          path: '/promoterAdd',
          component: resolve => require(['../components/page/promoter/PromoterAdd.vue'], resolve),
          meta: {title: '推广人添加'}
        },
         {
          path: '/promoterDetail',
          component: resolve => require(['../components/page/promoter/PromoterDetail.vue'], resolve),
          meta: {title: '推广人详情'}
        },

        //楼层管理
        {
          path: '/floorList',
          component: resolve => require(['../components/page/floor/floorList.vue'], resolve),
          meta: {title: '楼层管理'}
        },
        //新增楼层
        {
          path: '/addFloor',
          component: resolve => require(['../components/page/floor/addFloor.vue'], resolve),
          meta: {title: '新增楼层'}
        },
        //编辑楼层
        {
          path: '/editorFloor',
          component: resolve => require(['../components/page/floor/editorFloor.vue'], resolve),
          meta: {title: '编辑楼层'}
        },


        //专题管理
        {
          path: '/topic',
          component: resolve => require(['../components/page/topic/topicManagement.vue'], resolve),
          meta: {title: '专题管理', permission: true}
        },
        //新增专题
        {
          path: '/addTopic',
          component: resolve => require(['../components/page/topic/addTopic.vue'], resolve),
          meta: {title: '新增专题', permission: true}
        },
        //新增专题
        {
          path: '/editTopic&:id',
          component: resolve => require(['../components/page/topic/editTopic.vue'], resolve),
          meta: {title: '编辑专题', permission: true}
        },

        // 新增短信模版
        {
          path: '/addSms&:id&:type',
          component: resolve => require(['../components/page/sms/addSms.vue'], resolve),
          meta: {title: '编辑短信', permission: true}
        },
        // 短信模版管理
        {
          path: '/smsList',
          component: resolve => require(['../components/page/sms/smsList.vue'], resolve),
          meta: {title: '短信管理'}
        },

        //营销管理
        //color管理
        {
          path: '/colorManagement',
          component: resolve => require(['../components/page/marketing/colorManagement.vue'], resolve),
          meta: {title: 'color管理'}
        },
        {
          path: '/addColorManagement&:id',
          component: resolve => require(['../components/page/marketing/addColorManagement.vue'], resolve),
          meta: {title: '新增color'}
        },
        
      ]
    },
    // 登录
    {
      path: '/login',
      component: resolve => require(['../components/page/login/Login.vue'], resolve)
    },
    // 忘记密码
    {
      path: '/forgetpassword',
      component: resolve => require(['../components/page/login/ForgetPassword'], resolve)
    },
    // 重置密码
    {
      path: '/resetpassword',
      component: resolve => require(['../components/page/login/ResetPassword'], resolve)
    },
    {
      path: '/404',
      component: resolve => require(['../components/page/404.vue'], resolve)
    },
    {
      path: '/403',
      component: resolve => require(['../components/page/403.vue'], resolve)
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js